// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"58eda6bd","424":"502539c7","764":"b620b5f2"}[chunkId] + ".chunk.css";
};